import { roundTo } from "./tillHelpers";

/**
 * BUG-2620: the item summary a Prepare Bill print/reprint shows, rebuilt from the cart's items.
 *
 * Prepare Bill saved itemsSummery for 4 items (HMRS/11396, G1); the waiter later added 2 and the
 * reprint, which prints the live cart as it is, showed 6 lines with "Total Qty 4". Same rules as
 * the summary useCartOperations builds on every cart change: cancelled and zero-qty lines left
 * out, a Custom Mix line counted by its children, decimal-UOM lines kept apart.
 */
export const buildItemsSummary = (items, precision = 2) => {
  const summary = {
    decimalItems: { totalQty: 0, totalAmount: 0 },
    nonDecimalItems: { totalQty: 0, totalAmount: 0 },
    itemsQty: 0,
    items: 0,
  };
  const add = (line) => {
    const qty = Number(line?.weight) || 0;
    const key = line?.uomData?.[0]?.decimal === "Y" || line?.isDecimal ? "decimalItems" : "nonDecimalItems";
    summary.itemsQty += qty;
    summary.items += 1;
    summary[key].totalQty += qty;
    summary[key].totalAmount += roundTo(Number(line?.nettotal) || 0, precision);
  };
  for (const item of items || []) {
    if (!item || item.isCanceled === "Y" || Number(item.weight) === 0) continue;
    if (Array.isArray(item.children) && item.children.length > 0) item.children.forEach(add);
    else add(item);
  }
  summary.decimalItems.totalAmount = roundTo(summary.decimalItems.totalAmount, precision);
  summary.nonDecimalItems.totalAmount = roundTo(summary.nonDecimalItems.totalAmount, precision);
  return summary;
};

/** The cart to print with its item summary and total quantity taken from its current items. */
export const withFreshPrintSummary = (cart, precision = 2) => {
  if (!cart || !Array.isArray(cart.items)) return cart;
  const itemsSummery = buildItemsSummary(cart.items, precision);
  const totalQty = cart.items.reduce((sum, i) => (i && i.isCanceled !== "Y" ? sum + (Number(i.weight) || 0) : sum), 0);
  return { ...cart, itemsSummery, totalQty };
};
